function openNav()  {
  $('body').addClass('metanav-open');
}

function closeNav() {
    $('body').removeClass('metanav-open');
    $('.js-meta-submenu').removeClass('is-active');
    $('.js-submenu-link').removeClass('is-active');

}

function toggleSubNavigation($this) {

    var clickedItem = $this.data('meta-navigation-link'),
        clickedActiveItem = $('.js-submenu-link.is-active').data('meta-navigation-link'),

        matchingMenu = $('[data-meta-navigation="' + clickedItem + '"]'),
        $metaSubmenu = $('.js-meta-submenu');

    // remove all active states

    $('.js-submenu-link').removeClass('is-active');
    $this.addClass('is-active');
    $('body').removeClass('metasubnav-open');



    // if you clicked on the same item as already opened
    if (clickedActiveItem == clickedItem) {

        // And if the meta submenu is already active
        if ($metaSubmenu.hasClass('is-active')) {

            // remove the active state from the submenu to close it
            matchingMenu.removeClass('is-active');
            $metaSubmenu.removeClass('is-active');
            $this.removeClass('is-active');

        } else {
            // else add the active state to close it
            $metaSubmenu.addClass('is-active');
            $('body').addClass('metasubnav-open');
        }
    // else add the class is-active and open the menu
    } else {
        $('[data-meta-navigation]').removeClass('is-active');
        matchingMenu.addClass('is-active');
        $metaSubmenu.addClass('is-active');
        $('body').addClass('metasubnav-open');

    }

    // if the button is active
  //  $('[data-meta-navigation]').removeClass('is-active');

}


function clickHandlers() {
    $('.menu-link').on('click', 'a', function (e) {
        if ($('body.metanav-open').length) {
            closeNav();
        } else {
            openNav();
        }

    });

    $(document).keyup(function (e) {
        if (e.keyCode == 27) { closeNav(); }
    });

    $('.js-submenu-link').on('click', function (e) {

            toggleSubNavigation($(this));

    })
}


function resizeHandlers() {
    var resizeTimer;

    if (resizeTimer) {
        clearTimeout(resizeTimer);
    }

    resizeTimer = setTimeout(closeNav, 200);
}


function init() {
    clickHandlers();
    $(window).on('resize', closeNav);
}

// document ready init
$(init);
